import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'

import { messageFor } from '@/shared/api'
import { PrimaryButton, ScreenBackground } from '@/shared/ui'

/**
 * The nested `errorElement`. Errors are shown with the backend's own
 * `message_fa` where there is one — it is written for the user and is never
 * parsed or rewritten (backend-routes.md §1).
 */
export function RouteError() {
  const error = useRouteError()
  const navigate = useNavigate()

  const body = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : messageFor(error)

  return (
    <ScreenBackground variant="app" className="flex flex-col items-center justify-center gap-4 px-8">
      <h1 className="text-24 font-bold text-ink">مشکلی پیش آمد</h1>
      <p className="text-center text-15 text-ink-80">{body}</p>
      <div className="w-full max-w-[362px] pt-2">
        <PrimaryButton onClick={() => void navigate(0)}>تلاش دوباره</PrimaryButton>
      </div>
    </ScreenBackground>
  )
}
